// extracted by mini-css-extract-plugin
module.exports = {"switchControl":"SwitchControl_switchControl__3ImIT","switchControlText":"SwitchControl_switchControlText__3FRpp"};